export function CopyIcon({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label="Copy"
    >
      <path
        d="M12.2857 10.0312H7.14286C6.90714 10.0312 6.71429 9.84844 6.71429 9.625V3.125C6.71429 2.90156 6.90714 2.71875 7.14286 2.71875H10.7188C10.8313 2.71875 10.9411 2.76191 11.0214 2.83809L12.5884 4.32344C12.6687 4.39961 12.7143 4.50371 12.7143 4.61035V9.625C12.7143 9.84844 12.5214 10.0312 12.2857 10.0312ZM7.14286 11.25H12.2857C13.2312 11.25 14 10.5213 14 9.625V4.61035C14 4.17871 13.8205 3.76484 13.4991 3.46016L11.9295 1.9748C11.608 1.67012 11.1741 1.5 10.7188 1.5H7.14286C6.19732 1.5 5.42857 2.22871 5.42857 3.125V9.625C5.42857 10.5213 6.19732 11.25 7.14286 11.25ZM3.71429 4.75C2.76875 4.75 2 5.47871 2 6.375V12.875C2 13.7713 2.76875 14.5 3.71429 14.5H8.85714C9.80268 14.5 10.5714 13.7713 10.5714 12.875V12.4688H9.28571V12.875C9.28571 13.0984 9.09286 13.2812 8.85714 13.2812H3.71429C3.47857 13.2812 3.28571 13.0984 3.28571 12.875V6.375C3.28571 6.15156 3.47857 5.96875 3.71429 5.96875H4.14286V4.75H3.71429Z"
        fill="currentColor"
      />
    </svg>
  );
}
